export enum EFsContentType {
  RetailFolder = 'RetailFolder',
  RetailDocument = 'RetailDocument',
  RetailSurveyFolder = 'RetailSurveyFolder',
  RetailSurveyDocument = 'RetailSurveyDocument',
}
